/* eslint-disable */
!(function (t, e) {
    if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("moment"));
    else if ("function" == typeof define && define.amd) define(["moment"], e);
    else {
        var n = "object" == typeof exports ? e(require("moment")) : e(t.moment);
        for (var r in n) ("object" == typeof exports ? exports : t)[r] = n[r];
    }
})(window, function (t) {
    return (function (t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var a = (e[r] = { i: r, l: !1, exports: {} });
            return t[r].call(a.exports, a, a.exports, n), (a.l = !0), a.exports;
        }
        return (
            (n.m = t),
            (n.c = e),
            (n.d = function (t, e, r) {
                n.o(t, e) || Object.defineProperty(t, e, { configurable: !1, enumerable: !0, get: r });
            }),
            (n.r = function (t) {
                Object.defineProperty(t, "__esModule", { value: !0 });
            }),
            (n.n = function (t) {
                var e =
                    t && t.__esModule
                        ? function () {
                              return t.default;
                          }
                        : function () {
                              return t;
                          };
                return n.d(e, "a", e), e;
            }),
            (n.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
            }),
            (n.p = ""),
            n((n.s = 22))
        );
    })([
        function (t, e, n) {
            var r = n(15);
            "string" == typeof r && (r = [[t.i, r, ""]]), r.locals && (t.exports = r.locals);
            (0, n(10).default)("494e5759", r, !1, {});
        },
        function (t, e, n) {
            var r = n(17);
            "string" == typeof r && (r = [[t.i, r, ""]]), r.locals && (t.exports = r.locals);
            (0, n(10).default)("66614819", r, !1, {});
        },
        function (t, e, n) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.default = void 0);
            var r = c(n(14)),
                a = c(n(7)),
                i = c(n(19)),
                o = c(n(13)),
                s = c(n(12));
            function c(t) {
                return t && t.__esModule ? t : { default: t };
            }
            a.default.library.add(i.default, o.default);
            var l = {
                props: ["calendarIndex", "calendarCount", "month", "startDate", "endDate", "compare", "startDateCompare", "endDateCompare", "step"],
                data: function () {
                    return {};
                },
                computed: {
                    displayMonth: function () {
                        return s.default.utc(this.month).add(this.calendarIndex - 1, "month");
                    },
                    days: function () {
                        for (
                            var t = s.default.utc(this.displayMonth).startOf("isoWeek"),
                                e = s.default.utc(this.displayMonth).endOf("month").endOf("isoWeek").startOf("day").add(1, "day"),
                                n = s.default.duration(e.diff(t)).asDays(),
                                r = [],
                                a = 0;
                            a < n;

                        )
                            r.push(s.default.utc(t).add(a, "day")), a++;
                        return r;
                    },
                    daysOfFirstWeek: function () {
                        return this.days.slice(0, 7);
                    },
                },
                methods: {
                    dayClass: function (t) {
                        var e = [];
                        return (
                            t.isBetween(this.displayMonth, s.default.utc(this.displayMonth).endOf("month"), "days", "[]") || e.push("invisible"),
                            (t.isBetween(this.startDate, this.endDate, "days", "[]") || t.isSame(this.startDate)) && e.push("daterangepicker-range"),
                            this.compare && (t.isBetween(this.startDateCompare, this.endDateCompare, "days", "[]") || t.isSame(this.startDateCompare)) && e.push("daterangepicker-range-compare"),
                            e.push("daterangepicker-cursor-pointer"),
                            e.join(" ")
                        );
                    },
                    dayClick: function (t) {
                        this.selectDate(t);
                    },
                    blurOnHover: function () {
                        this.$emit("blurOnHover");
                    },
                    goToPrevMonth: function () {
                        this.$emit("goToPrevMonth");
                    },
                    goToNextMonth: function () {
                        this.$emit("goToNextMonth");
                    },
                    selectDate: function (t) {
                        this.$emit("selectDate", t);
                    },
                    nextStep: function () {
                        this.$emit("nextStep");
                    },
                },
                watch: {},
                filters: {},
                components: { FontAwesomeIcon: r.default },
            };
            e.default = l;
        },
        function (t, e, n) {
            "use strict";
            n.r(e);
            var r = n(2),
                a = n.n(r);
            for (var i in r)
                "default" !== i &&
                    (function (t) {
                        n.d(e, t, function () {
                            return r[t];
                        });
                    })(i);
            e.default = a.a;
        },
        function (t, e, n) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 }), (e.default = void 0);
            var r = c(n(21)),
                a = c(n(14)),
                i = c(n(7)),
                o = c(n(13)),
                s = c(n(12));
            function c(t) {
                return t && t.__esModule ? t : { default: t };
            }
            i.default.library.add(o.default);
            var l = {
                props: {
                    calendarCount: { type: Number, default: 2 },
                    allowCompare: { type: Boolean, default: !0 },
                    ranges: {
                        type: Object,
                        default: function () {
                            return {
                                currentMonth: { label: "Current month", startDate: s.default.utc().startOf("month"), endDate: s.default.utc().endOf("month").startOf("day") },
                                lastMonth: { label: "Last month", startDate: s.default.utc().subtract(1, "month").startOf("month"), endDate: s.default.utc().subtract(1, "month").endOf("month").startOf("day") },
                            };
                        },
                    },
                    defaultRangeSelect: { type: String, default: "currentMonth" },
                    defaultRangeSelectCompare: { type: String, default: "lastMonth" },
                },
                data: function () {
                    return {
                        startDate: s.default.utc(),
                        endDate: s.default.utc(),
                        startDateCompare: s.default.utc(),
                        endDateCompare: s.default.utc(),
                        startDateOnCancel: null,
                        endDateOnCancel: null,
                        startDateCompareOnCancel: null,
                        endDateCompareOnCancel: null,
                        rangeSelect: null,
                        rangeSelectCompare: null,
                        compare: !1,
                        month: s.default.utc().subtract(1, "month").startOf("month"),
                        step: null,
                    };
                },
                computed: {
                    nextMonth: function () {
                        return s.default.utc(this.month).add(1, "month");
                    },
                    range: function () {
                        return this.startDate, this.endDate;
                    },
                    rangeCompare: function () {
                        return this.startDateCompare, this.endDateCompare;
                    },
                },
                methods: {
                    blurOnHover: function (){
                        const step = this.step
                        this.$refs.startDate.blur()
                        this.$refs.endDate.blur()
                    if(step == "selectEndDate")
                    {
                        this.step = step
                    }
                    },
                    goToPrevMonth: function () {
                        this.month = s.default.utc(this.month).subtract(1, "month");
                    },
                    goToNextMonth: function () {
                        this.month = s.default.utc(this.month).add(1, "month");
                    },
                    selectRange: function (t) {
                        for (var e = !1, n = Object.keys(this.ranges), r = 0; r < n.length; r++) {
                            var a = n[r],
                                i = this.ranges[a];
                            t == a && ((e = !0), this.startDate.isSame(i.startDate) || (this.startDate = s.default.utc(i.startDate)), this.endDate.isSame(i.endDate) || (this.endDate = s.default.utc(i.endDate)));
                        }
                        if(this.startDateOnCancel== null && this.endDateOnCancel == null){
                            this.startDateOnCancel = this.startDate;
                            this.endDateOnCancel = this.endDate;
                        }
                        e || null != this.step || ((this.step = "selectStartDate"), this.$refs.startDate.focus());
                    },
                    selectRangeCompare: function (t) {
                        for (var e = !1, n = Object.keys(this.ranges), r = 0; r < n.length; r++) {
                            var a = n[r],
                                i = this.ranges[a];
                            t == a && ((e = !0), this.startDateCompare.isSame(i.startDate) || (this.startDateCompare = s.default.utc(i.startDate)), this.endDateCompare.isSame(i.endDate) || (this.endDateCompare = s.default.utc(i.endDate)));
                        }
                        if(this.startDateCompareOnCancel== null && this.endDateCompareOnCancel == null){
                            this.startDateCompareOnCancel = this.startDateCompare;
                            this.endDateCompareOnCancel = this.endDateCompare;
                        }
                        e || null != this.step || ((this.step = "selectStartDateCompare"), this.$refs.startDateCompare.focus());
                    },
                    selectDate: function (t) {
                        if(this.step == null)
                        {
                            this.step = "selectStartDate"
                        };
                        let lastEndDate = this.endDate
                        "selectStartDate" == this.step
                            ? (this.startDate = t, this.step = "selectEndDate", this.$refs.startDate.blur())
                            : "selectEndDate" == this.step
                            ? (this.endDate = t, this.step = null, this.$refs.endDate.blur() )
                            : "selectStartDateCompare" == this.step
                            ? (this.startDateCompare = t)
                            : "selectEndDateCompare" == this.step && (this.endDateCompare = t);
                            
                        if(this.startDate > this.endDate && this.step !== "selectEndDate"){
                            this.endDate = lastEndDate
                            this.step = "selectEndDate"
                        }
                        if(this.startDate > this.endDate && this.step == "selectEndDate"){
                            this.endDate = this.startDate
                            this.step = "selectEndDate"
                        }
                    },
                     nextStep: function () {
                        "selectStartDate" == this.step
                            ? ((this.step = "selectEndDate"), this.$refs.endDate.focus())
                            : "selectEndDate" == this.step
                            ? ((this.step = null), this.$refs.endDate.blur())
                            : "selectStartDateCompare" == this.step
                            ? ((this.step = "selectEndDateCompare"), this.$refs.endDateCompare.focus())
                            : "selectEndDateCompare" == this.step && ((this.step = null), this.$refs.endDateCompare.blur());
                    },
                    inputDate: function (t) {
                        var e = s.default.utc(t.target.value, "YYYY-MM-DD");
                        e.isValid() && this.selectDate(e), this.nextStep();
                    },
                    submit: function () {
                        this.startDateOnCancel = this.startDate;
                        this.endDateOnCancel = this.endDate;
                        this.startDateCompareOnCancel = this.startDateCompare;
                        this.endDateCompareOnCancel = this.endDateCompare;
                        this.step = null;
                        this.$emit("submit", { startDate: this.startDate, endDate: this.endDate, compare: this.compare, startDateCompare: this.startDateCompare, endDateCompare: this.endDateCompare });
                    },
                    cancel: function () {
                        this.startDate = this.startDateOnCancel;
                        this.endDate = this.endDateOnCancel;
                        this.startDateCompare = this.startDateCompareOnCancel;
                        this.endDateCompare = this.endDateCompareOnCancel;
                        this.step = null;
                        this.$emit("cancel");
                    },
                },
                watch: {
                    rangeSelect: function (t) {
                        this.selectRange(t);
                    },
                    rangeSelectCompare: function (t) {
                        this.selectRangeCompare(t);
                    },
                    range: function () {
                        for (var t = !1, e = Object.keys(this.ranges), n = 0; n < e.length; n++) {
                            var r = e[n],
                                a = this.ranges[r];
                            this.startDate.isSame(a.startDate) && this.endDate.isSame(a.endDate) && ((t = !0), this.rangeSelect != r && (this.rangeSelect = r));
                        }
                        t || ("custom" != this.rangeSelect && (this.rangeSelect = "custom"));
                    },
                    rangeCompare: function () {
                        for (var t = !1, e = Object.keys(this.ranges), n = 0; n < e.length; n++) {
                            var r = e[n],
                                a = this.ranges[r];
                            this.startDateCompare.isSame(a.startDate) && this.endDateCompare.isSame(a.endDate) && ((t = !0), this.rangeSelectCompare != r && (this.rangeSelectCompare = r));
                        }
                        t || ("custom" != this.rangeSelectCompare && (this.rangeSelectCompare = "custom"));
                    },
                },
                filters: {
                    dateFormat: function (t) {
                        return t ? t.format("YYYY-MM-DD") : "";
                    },
                },
                created: function () {
                    (this.rangeSelect = this.defaultRangeSelect), (this.rangeSelectCompare = this.defaultRangeSelectCompare);
                },
                components: { DateRangePickerCalendar: r.default, FontAwesomeIcon: a.default },
            };
            e.default = l;
        },
        function (t, e, n) {
            "use strict";
            n.r(e);
            var r = n(4),
                a = n.n(r);
            for (var i in r)
                "default" !== i &&
                    (function (t) {
                        n.d(e, t, function () {
                            return r[t];
                        });
                    })(i);
            e.default = a.a;
        },
        function (t, e, n) {
            "use strict";
            function r(t, e, n, r, a, i, o, s) {
                var c,
                    l = "function" == typeof t ? t.options : t;
                if (
                    (e && ((l.render = e), (l.staticRenderFns = n), (l._compiled = !0)),
                    r && (l.functional = !0),
                    i && (l._scopeId = "data-v-" + i),
                    o
                        ? ((c = function (t) {
                              (t = t || (this.$vnode && this.$vnode.ssrContext) || (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext)) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__),
                                  a && a.call(this, t),
                                  t && t._registeredComponents && t._registeredComponents.add(o);
                          }),
                          (l._ssrRegister = c))
                        : a &&
                          (c = s
                              ? function () {
                                    a.call(this, this.$root.$options.shadowRoot);
                                }
                              : a),
                    c)
                )
                    if (l.functional) {
                        l._injectStyles = c;
                        var u = l.render;
                        l.render = function (t, e) {
                            return c.call(e), u(t, e);
                        };
                    } else {
                        var f = l.beforeCreate;
                        l.beforeCreate = f ? [].concat(f, c) : [c];
                    }
                return { exports: t, options: l };
            }
            n.d(e, "a", function () {
                return r;
            });
        },
        function (t, e, n) {
            "use strict";
            n.r(e),
                n.d(e, "config", function () {
                    return de;
                }),
                n.d(e, "icon", function () {
                    return se;
                }),
                n.d(e, "noAuto", function () {
                    return ae;
                }),
                n.d(e, "layer", function () {
                    return le;
                }),
                n.d(e, "text", function () {
                    return ce;
                }),
                n.d(e, "library", function () {
                    return re;
                }),
                n.d(e, "dom", function () {
                    return ie;
                }),
                n.d(e, "parse", function () {
                    return oe;
                }),
                n.d(e, "findIconDefinition", function () {
                    return ee;
                });
            /*!
             * Font Awesome Free 5.0.9 by @fontawesome - https://fontawesome.com
             * License - https://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
             */
            var r = function () {},
                a = {},
                i = {},
                o = null,
                s = { mark: r, measure: r };
            try {
                "undefined" != typeof window && (a = window), "undefined" != typeof document && (i = document), "undefined" != typeof MutationObserver && (o = MutationObserver), "undefined" != typeof performance && (s = performance);
            } catch (t) {}
            var c = (a.navigator || {}).userAgent,
                l = void 0 === c ? "" : c,
                u = a,
                f = i,
                d = o,
                p = s,
                m = !!u.document,
                h = !!f.documentElement && !!f.head && "function" == typeof f.addEventListener && "function" == typeof f.createElement,
                g = ~l.indexOf("MSIE") || ~l.indexOf("Trident/"),
                v = 16,
                b = "data-fa-i2svg",
                y = "data-fa-pseudo-element",
                x = "fontawesome-i2svg",
                w = (function () {
                    try {
                        return !0;
                    } catch (t) {
                        return !1;
                    }
                })(),
                k = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                C = k.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
                _ = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"],
                D = [
                    "xs",
                    "sm",
                    "lg",
                    "fw",
                    "ul",
                    "li",
                    "border",
                    "pull-left",
                    "pull-right",
                    "spin",
                    "pulse",
                    "rotate-90",
                    "rotate-180",
                    "rotate-270",
                    "flip-horizontal",
                    "flip-vertical",
                    "stack",
                    "stack-1x",
                    "stack-2x",
                    "inverse",
                    "layers",
                    "layers-text",
                    "layers-counter",
                ]
                    .concat(
                        k.map(function (t) {
                            return t + "x";
                        })
                    )
                    .concat(
                        C.map(function (t) {
                            return "w-" + t;
                        })
                    ),
                S = function (t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                },
                O = (function () {
                    function t(t, e) {
                        for (var n = 0; n < e.length; n++) {
                            var r = e[n];
                            (r.enumerable = r.enumerable || !1), (r.configurable = !0), "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                        }
                    }
                    return function (e, n, r) {
                        return n && t(e.prototype, n), r && t(e, r), e;
                    };
                })(),
                M =
                    Object.assign ||
                    function (t) {
                        for (var e = 1; e < arguments.length; e++) {
                            var n = arguments[e];
                            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                        }
                        return t;
                    },
                A = function (t) {
                    if (Array.isArray(t)) {
                        for (var e = 0, n = Array(t.length); e < t.length; e++) n[e] = t[e];
                        return n;
                    }
                    return Array.from(t);
                },
                N = u.FontAwesomeConfig || {},
                j = Object.keys(N),
                E = M(
                    {
                        familyPrefix: "fa",
                        replacementClass: "svg-inline--fa",
                        autoReplaceSvg: !0,
                        autoAddCss: !0,
                        autoA11y: !0,
                        searchPseudoElements: !1,
                        observeMutations: !0,
                        keepOriginalSource: !0,
                        measurePerformance: !1,
                        showMissingIcons: !0,
                    },
                    N
                );
            E.autoReplaceSvg || (E.observeMutations = !1);
            var z = M({}, E);
            function T(t) {
                var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).asNewDefault,
                    n = void 0 !== e && e,
                    r = Object.keys(z),
                    a = n
                        ? function (t) {
                              return ~r.indexOf(t) && !~j.indexOf(t);
                          }
                        : function (t) {
                              return ~r.indexOf(t);
                          };
                Object.keys(t).forEach(function (e) {
                    a(e) && (z[e] = t[e]);
                });
            }
            u.FontAwesomeConfig = z;
            var P = u || {};
            P.___FONT_AWESOME___ || (P.___FONT_AWESOME___ = {}),
                P.___FONT_AWESOME___.styles || (P.___FONT_AWESOME___.styles = {}),
                P.___FONT_AWESOME___.hooks || (P.___FONT_AWESOME___.hooks = {}),
                P.___FONT_AWESOME___.shims || (P.___FONT_AWESOME___.shims = []);
            var L = P.___FONT_AWESOME___,
                I = [],
                F = !1;
            h &&
                ((F = (f.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(f.readyState)) ||
                    f.addEventListener("DOMContentLoaded", function t() {
                        f.removeEventListener("DOMContentLoaded", t),
                            (F = 1),
                            I.map(function (t) {
                                return t();
                            });
                    }));
            var R = function (t) {
                    h && (F ? setTimeout(t, 0) : I.push(t));
                },
                B = v,
                W = { size: 16, x: 0, y: 0, rotate: 0, flipX: !1, flipY: !1 };
            function $(t) {
                if (t && h) {
                    var e = f.createElement("style");
                    e.setAttribute("type", "text/css"), (e.innerHTML = t);
                    for (var n = f.head.childNodes, r = null, a = n.length - 1; a > -1; a--) {
                        var i = n[a],
                            o = (i.tagName || "").toUpperCase();
                        ["STYLE", "LINK"].indexOf(o) > -1 && (r = i);
                    }
                    return f.head.insertBefore(e, r), t;
                }
            }
            var Y = 0;
            function U() {
                return ++Y;
            }
            function X(t) {
                for (var e = [], n = (t || []).length >>> 0; n--; ) e[n] = t[n];
                return e;
            }
            function H(t) {
                return t.classList
                    ? X(t.classList)
                    : (t.getAttribute("class") || "").split(" ").filter(function (t) {
                          return t;
                      });
            }
            function V(t, e) {
                var n,
                    r = e.split("-"),
                    a = r[0],
                    i = r.slice(1).join("-");
                return a !== t || "" === i || ((n = i), ~D.indexOf(n)) ? null : i;
            }
            function q(t) {
                return ("" + t).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            }
            function K(t) {
                return Object.keys(t || {}).reduce(function (e, n) {
                    return e + (n + ": ") + t[n] + ";";
                }, "");
            }
            function G(t) {
                return t.size !== W.size || t.x !== W.x || t.y !== W.y || t.rotate !== W.rotate || t.flipX || t.flipY;
            }
            function J(t) {
                var e = t.transform,
                    n = t.containerWidth,
                    r = t.iconWidth;
                return {
                    outer: { transform: "translate(" + n / 2 + " 256)" },
                    inner: { transform: "translate(" + 32 * e.x + ", " + 32 * e.y + ") " + " " + ("scale(" + (e.size / 16) * (e.flipX ? -1 : 1) + ", " + (e.size / 16) * (e.flipY ? -1 : 1) + ") ") + " " + ("rotate(" + e.rotate + " 0 0)") },
                    path: { transform: "translate(" + (r / 2) * -1 + " -256)" },
                };
            }
            var Z = { x: 0, y: 0, width: "100%", height: "100%" },
                Q = function (t) {
                    var e = t.children,
                        n = t.attributes,
                        r = t.main,
                        a = t.mask,
                        i = t.transform,
                        o = r.width,
                        s = r.icon,
                        c = a.width,
                        l = a.icon,
                        u = J({ transform: i, containerWidth: c, iconWidth: o }),
                        f = { tag: "rect", attributes: M({}, Z, { fill: "white" }) },
                        d = { tag: "g", attributes: M({}, u.inner), children: [{ tag: "path", attributes: M({}, s.attributes, u.path, { fill: "black" }) }] },
                        p = { tag: "g", attributes: M({}, u.outer), children: [d] },
                        m = "mask-" + U(),
                        h = "clip-" + U(),
                        g = {
                            tag: "defs",
                            children: [
                                { tag: "clipPath", attributes: { id: h }, children: [l] },
                                { tag: "mask", attributes: M({}, Z, { id: m, maskUnits: "userSpaceOnUse", maskContentUnits: "userSpaceOnUse" }), children: [f, p] },
                            ],
                        };
                    return e.push(g, { tag: "rect", attributes: M({ fill: "currentColor", "clip-path": "url(#" + h + ")", mask: "url(#" + m + ")" }, Z) }), { children: e, attributes: n };
                },
                tt = function (t) {
                    var e = t.children,
                        n = t.attributes,
                        r = t.main,
                        a = t.transform,
                        i = K(t.styles);
                    if ((i.length > 0 && (n.style = i), G(a))) {
                        var o = J({ transform: a, containerWidth: r.width, iconWidth: r.width });
                        e.push({ tag: "g", attributes: M({}, o.outer), children: [{ tag: "g", attributes: M({}, o.inner), children: [{ tag: r.icon.tag, children: r.icon.children, attributes: M({}, r.icon.attributes, o.path) }] }] });
                    } else e.push(r.icon);
                    return { children: e, attributes: n };
                },
                et = function (t) {
                    var e = t.children,
                        n = t.main,
                        r = t.mask,
                        a = t.attributes,
                        i = t.styles,
                        o = t.transform;
                    if (G(o) && n.found && !r.found) {
                        var s = { x: n.width / n.height / 2, y: 0.5 };
                        a.style = K(M({}, i, { "transform-origin": s.x + o.x / 16 + "em " + (s.y + o.y / 16) + "em" }));
                    }
                    return [{ tag: "svg", attributes: a, children: e }];
                },
                nt = function (t) {
                    var e = t.prefix,
                        n = t.iconName,
                        r = t.children,
                        a = t.attributes,
                        i = t.symbol,
                        o = !0 === i ? e + "-" + z.familyPrefix + "-" + n : i;
                    return [{ tag: "svg", attributes: { style: "display: none;" }, children: [{ tag: "symbol", attributes: M({}, a, { id: o }), children: r }] }];
                };
            function rt(t) {
                var e = t.icons,
                    n = e.main,
                    r = e.mask,
                    a = t.prefix,
                    i = t.iconName,
                    o = t.transform,
                    s = t.symbol,
                    c = t.title,
                    l = t.extra,
                    u = t.watchable,
                    f = void 0 !== u && u,
                    d = r.found ? r : n,
                    p = d.width,
                    m = d.height,
                    h = "fa-w-" + Math.ceil((p / m) * 16),
                    g = [z.replacementClass, i ? z.familyPrefix + "-" + i : "", h].concat(l.classes).join(" "),
                    v = { children: [], attributes: M({}, l.attributes, { "data-prefix": a, "data-icon": i, class: g, role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 " + p + " " + m }) };
                f && (v.attributes[b] = ""), c && v.children.push({ tag: "title", attributes: { id: v.attributes["aria-labelledby"] || "title-" + U() }, children: [c] });
                var y = M({}, v, { prefix: a, iconName: i, main: n, mask: r, transform: o, symbol: s, styles: l.styles }),
                    x = r.found && n.found ? Q(y) : tt(y),
                    w = x.children,
                    k = x.attributes;
                return (y.children = w), (y.attributes = k), s ? nt(y) : et(y);
            }
            function at(t) {
                var e = t.content,
                    n = t.width,
                    r = t.height,
                    a = t.transform,
                    i = t.title,
                    o = t.extra,
                    s = t.watchable,
                    c = void 0 !== s && s,
                    l = M({}, o.attributes, i ? { title: i } : {}, { class: o.classes.join(" ") });
                c && (l[b] = "");
                var u = M({}, o.styles);
                G(a) &&
                    ((u.transform = (function (t) {
                        var e = t.transform,
                            n = t.width,
                            r = void 0 === n ? v : n,
                            a = t.height,
                            i = void 0 === a ? v : a,
                            o = t.startCentered,
                            s = void 0 !== o && o,
                            c = "";
                        return (
                            (c +=
                                s && g
                                    ? "translate(" + (e.x / B - r / 2) + "em, " + (e.y / B - i / 2) + "em) "
                                    : s
                                    ? "translate(calc(-50% + " + e.x / B + "em), calc(-50% + " + e.y / B + "em)) "
                                    : "translate(" + e.x / B + "em, " + e.y / B + "em) "),
                            (c += "scale(" + (e.size / B) * (e.flipX ? -1 : 1) + ", " + (e.size / B) * (e.flipY ? -1 : 1) + ") "),
                            (c += "rotate(" + e.rotate + "deg) ")
                        );
                    })({ transform: a, startCentered: !0, width: n, height: r })),
                    (u["-webkit-transform"] = u.transform));
                var f = K(u);
                f.length > 0 && (l.style = f);
                var d = [];
                return d.push({ tag: "span", attributes: l, children: [e] }), i && d.push({ tag: "span", attributes: { class: "sr-only" }, children: [i] }), d;
            }
            var it = function () {},
                ot = z.measurePerformance && p && p.mark && p.measure ? p : { mark: it, measure: it },
                st = function (t) {
                    ot.mark('FA "5.0.9" ' + t + " ends"), ot.measure('FA "5.0.9" ' + t, 'FA "5.0.9" ' + t + " begins", 'FA "5.0.9" ' + t + " ends");
                },
                ct = {
                    begin: function (t) {
                        return (
                            ot.mark('FA "5.0.9" ' + t + " begins"),
                            function () {
                                return st(t);
                            }
                        );
                    },
                    end: st,
                },
                lt = function (t, e, n, r) {
                    var a,
                        i,
                        o,
                        s = Object.keys(t),
                        c = s.length,
                        l =
                            void 0 !== r
                                ? (function (t, e) {
                                      return function (n, r, a, i) {
                                          return t.call(e, n, r, a, i);
                                      };
                                  })(e, r)
                                : e;
                    for (void 0 === n ? ((a = 1), (o = t[s[0]])) : ((a = 0), (o = n)); a < c; a++) o = l(o, t[(i = s[a])], i, t);
                    return o;
                },
                ut = L.styles,
                ft = L.shims,
                dt = {},
                pt = {},
                mt = {},
                ht = function () {
                    var t = function (t) {
                        return lt(
                            ut,
                            function (e, n, r) {
                                return (e[r] = lt(n, t, {})), e;
                            },
                            {}
                        );
                    };
                    (dt = t(function (t, e, n) {
                        return (t[e[3]] = n), t;
                    })),
                        (pt = t(function (t, e, n) {
                            var r = e[2];
                            return (
                                (t[n] = n),
                                r.forEach(function (e) {
                                    t[e] = n;
                                }),
                                t
                            );
                        }));
                    var e = "far" in ut;
                    mt = lt(
                        ft,
                        function (t, n) {
                            var r = n[0],
                                a = n[1],
                                i = n[2];
                            return "far" !== a || e || (a = "fas"), (t[r] = { prefix: a, iconName: i }), t;
                        },
                        {}
                    );
                };
            ht();
            var gt = L.styles,
                vt = function () {
                    return { prefix: null, iconName: null, rest: [] };
                };
            function bt(t) {
                return t.reduce(function (t, e) {
                    var n = V(z.familyPrefix, e);
                    if (gt[e]) t.prefix = e;
                    else if (n) {
                        var r = "fa" === t.prefix ? mt[n] || { prefix: null, iconName: null } : {};
                        (t.iconName = r.iconName || n), (t.prefix = r.prefix || t.prefix);
                    } else e !== z.replacementClass && 0 !== e.indexOf("fa-w-") && t.rest.push(e);
                    return t;
                }, vt());
            }
            function yt(t, e, n) {
                if (t && t[e] && t[e][n]) return { prefix: e, iconName: n, icon: t[e][n] };
            }
            function xt(t) {
                var e = t.tag,
                    n = t.attributes,
                    r = void 0 === n ? {} : n,
                    a = t.children,
                    i = void 0 === a ? [] : a;
                return "string" == typeof t
                    ? q(t)
                    : "<" +
                          e +
                          " " +
                          (function (t) {
                              return Object.keys(t || {})
                                  .reduce(function (e, n) {
                                      return e + (n + '="') + q(t[n]) + '" ';
                                  }, "")
                                  .trim();
                          })(r) +
                          ">" +
                          i.map(xt).join("") +
                          "</" +
                          e +
                          ">";
            }
            var wt = function () {};
            function kt(t) {
                return "string" == typeof (t.getAttribute ? t.getAttribute(b) : null);
            }
            var Ct = {
                replace: function (t) {
                    var e = t[0],
                        n = t[1]
                            .map(function (t) {
                                return xt(t);
                            })
                            .join("\n");
                    if (e.parentNode && e.outerHTML) e.outerHTML = n + (z.keepOriginalSource && "svg" !== e.tagName.toLowerCase() ? "\x3c!-- " + e.outerHTML + " --\x3e" : "");
                    else if (e.parentNode) {
                        var r = document.createElement("span");
                        e.parentNode.replaceChild(r, e), (r.outerHTML = n);
                    }
                },
                nest: function (t) {
                    var e = t[0],
                        n = t[1];
                    if (~H(e).indexOf(z.replacementClass)) return Ct.replace(t);
                    var r = new RegExp(z.familyPrefix + "-.*");
                    delete n[0].attributes.style;
                    var a = n[0].attributes.class.split(" ").reduce(
                        function (t, e) {
                            return e === z.replacementClass || e.match(r) ? t.toSvg.push(e) : t.toNode.push(e), t;
                        },
                        { toNode: [], toSvg: [] }
                    );
                    n[0].attributes.class = a.toSvg.join(" ");
                    var i = n
                        .map(function (t) {
                            return xt(t);
                        })
                        .join("\n");
                    e.setAttribute("class", a.toNode.join(" ")), e.setAttribute(b, ""), (e.innerHTML = i);
                },
            };
            function _t(t, e) {
                var n = "function" == typeof e ? e : wt;
                0 === t.length
                    ? n()
                    : (
                          u.requestAnimationFrame ||
                          function (t) {
                              return t();
                          }
                      )(function () {
                          var e = !0 === z.autoReplaceSvg ? Ct.replace : Ct[z.autoReplaceSvg] || Ct.replace,
                              r = ct.begin("mutate");
                          t.map(e), r(), n();
                      });
            }
            var Dt = !1;
            var St = null;
            var Ot = function (t) {
                var e = t.getAttribute("style"),
                    n = [];
                return (
                    e &&
                        (n = e.split(";").reduce(function (t, e) {
                            var n = e.split(":"),
                                r = n[0],
                                a = n.slice(1);
                            return r && a.length > 0 && (t[r] = a.join(":").trim()), t;
                        }, {})),
                    n
                );
            };
            var Mt = function (t) {
                    var e,
                        n,
                        r = t.getAttribute("data-prefix"),
                        a = t.getAttribute("data-icon"),
                        i = void 0 !== t.innerText ? t.innerText.trim() : "",
                        o = bt(H(t));
                    return (
                        r && a && ((o.prefix = r), (o.iconName = a)),
                        o.prefix && i.length > 1
                            ? (o.iconName = ((e = o.prefix), (n = t.innerText), pt[e][n]))
                            : o.prefix &&
                              1 === i.length &&
                              (o.iconName = (function (t, e) {
                                  return dt[t][e];
                              })(
                                  o.prefix,
                                  (function (t) {
                                      for (var e = "", n = 0; n < t.length; n++) e += ("000" + t.charCodeAt(n).toString(16)).slice(-4);
                                      return e;
                                  })(t.innerText)
                              )),
                        o
                    );
                },
                At = function (t) {
                    var e = { size: 16, x: 0, y: 0, flipX: !1, flipY: !1, rotate: 0 };
                    return t
                        ? t
                              .toLowerCase()
                              .split(" ")
                              .reduce(function (t, e) {
                                  var n = e.toLowerCase().split("-"),
                                      r = n[0],
                                      a = n.slice(1).join("-");
                                  if (r && "h" === a) return (t.flipX = !0), t;
                                  if (r && "v" === a) return (t.flipY = !0), t;
                                  if (((a = parseFloat(a)), isNaN(a))) return t;
                                  switch (r) {
                                      case "grow":
                                          t.size = t.size + a;
                                          break;
                                      case "shrink":
                                          t.size = t.size - a;
                                          break;
                                      case "left":
                                          t.x = t.x - a;
                                          break;
                                      case "right":
                                          t.x = t.x + a;
                                          break;
                                      case "up":
                                          t.y = t.y - a;
                                          break;
                                      case "down":
                                          t.y = t.y + a;
                                          break;
                                      case "rotate":
                                          t.rotate = t.rotate + a;
                                  }
                                  return t;
                              }, e)
                        : e;
                },
                Nt = function (t) {
                    return At(t.getAttribute("data-fa-transform"));
                },
                jt = function (t) {
                    var e = t.getAttribute("data-fa-symbol");
                    return null !== e && ("" === e || e);
                },
                Et = function (t) {
                    var e = X(t.attributes).reduce(function (t, e) {
                            return "class" !== t.name && "style" !== t.name && (t[e.name] = e.value), t;
                        }, {}),
                        n = t.getAttribute("title");
                    return z.autoA11y && (n ? (e["aria-labelledby"] = z.replacementClass + "-title-" + U()) : (e["aria-hidden"] = "true")), e;
                },
                zt = function (t) {
                    var e = t.getAttribute("data-fa-mask");
                    return e
                        ? bt(
                              e.split(" ").map(function (t) {
                                  return t.trim();
                              })
                          )
                        : vt();
                };
            function Tt(t) {
                (this.name = "MissingIcon"), (this.message = t || "Icon unavailable"), (this.stack = new Error().stack);
            }
            (Tt.prototype = Object.create(Error.prototype)), (Tt.prototype.constructor = Tt);
            var Pt = { fill: "currentColor" },
                Lt = { attributeType: "XML", repeatCount: "indefinite", dur: "2s" },
                It = {
                    tag: "path",
                    attributes: M({}, Pt, {
                        d:
                            "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z",
                    }),
                },
                Ft = M({}, Lt, { attributeName: "opacity" }),
                Rt = {
                    tag: "g",
                    children: [
                        It,
                        {
                            tag: "circle",
                            attributes: M({}, Pt, { cx: "256", cy: "364", r: "28" }),
                            children: [
                                { tag: "animate", attributes: M({}, Lt, { attributeName: "r", values: "28;14;28;28;14;28;" }) },
                                { tag: "animate", attributes: M({}, Ft, { values: "1;0;1;1;0;1;" }) },
                            ],
                        },
                        {
                            tag: "path",
                            attributes: M({}, Pt, {
                                opacity: "1",
                                d:
                                    "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z",
                            }),
                            children: [{ tag: "animate", attributes: M({}, Ft, { values: "1;0;0;0;0;1;" }) }],
                        },
                        {
                            tag: "path",
                            attributes: M({}, Pt, { opacity: "0", d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z" }),
                            children: [{ tag: "animate", attributes: M({}, Ft, { values: "0;0;1;1;0;0;" }) }],
                        },
                    ],
                },
                Bt = L.styles,
                Wt = "fa-layers-text",
                $t = /Font Awesome 5 (Solid|Regular|Light|Brands)/,
                Yt = { Solid: "fas", Regular: "far", Light: "fal", Brands: "fab" };
            function Ut(t, e) {
                var n = { found: !1, width: 512, height: 512, icon: Rt };
                if (t && e && Bt[e] && Bt[e][t]) {
                    var r = Bt[e][t];
                    n = { found: !0, width: r[0], height: r[1], icon: { tag: "path", attributes: { fill: "currentColor", d: r.slice(4)[0] } } };
                } else if (t && e && !z.showMissingIcons) throw new Tt("Icon is missing for prefix " + e + " with icon name " + t);
                return n;
            }
            function Xt(t) {
                var e = (function (t) {
                    var e = Mt(t),
                        n = e.iconName,
                        r = e.prefix,
                        a = e.rest,
                        i = Ot(t),
                        o = Nt(t),
                        s = jt(t),
                        c = Et(t),
                        l = zt(t);
                    return { iconName: n, title: t.getAttribute("title"), prefix: r, transform: o, symbol: s, mask: l, extra: { classes: a, styles: i, attributes: c } };
                })(t);
                return ~e.extra.classes.indexOf(Wt)
                    ? (function (t, e) {
                          var n = e.title,
                              r = e.transform,
                              a = e.extra,
                              i = null,
                              o = null;
                          if (g) {
                              var s = parseInt(getComputedStyle(t).fontSize, 10),
                                  c = t.getBoundingClientRect();
                              (i = c.width / s), (o = c.height / s);
                          }
                          return z.autoA11y && !n && (a.attributes["aria-hidden"] = "true"), [t, at({ content: t.innerHTML, width: i, height: o, transform: r, title: n, extra: a, watchable: !0 })];
                      })(t, e)
                    : (function (t, e) {
                          var n = e.iconName,
                              r = e.title,
                              a = e.prefix,
                              i = e.transform,
                              o = e.symbol,
                              s = e.mask,
                              c = e.extra;
                          return [t, rt({ icons: { main: Ut(n, a), mask: Ut(s.iconName, s.prefix) }, prefix: a, iconName: n, transform: i, symbol: o, mask: s, title: r, extra: c, watchable: !0 })];
                      })(t, e);
            }
            function Ht(t) {
                "function" == typeof t.remove ? t.remove() : t && t.parentNode && t.parentNode.removeChild(t);
            }
            function Vt(t) {
                if (h) {
                    var e = ct.begin("searchPseudoElements");
                    (Dt = !0),
                        (function () {
                            X(t.querySelectorAll("*")).forEach(function (t) {
                                [":before", ":after"].forEach(function (e) {
                                    var n = u.getComputedStyle(t, e),
                                        r = n.getPropertyValue("font-family").match($t),
                                        a = X(t.children).filter(function (t) {
                                            return t.getAttribute(y) === e;
                                        })[0];
                                    if ((a && (a.nextSibling && a.nextSibling.textContent.indexOf(y) > -1 && Ht(a.nextSibling), Ht(a), (a = null)), r && !a)) {
                                        var i = n.getPropertyValue("content"),
                                            o = f.createElement("i");
                                        o.setAttribute("class", "" + Yt[r[1]]), o.setAttribute(y, e), (o.innerText = 3 === i.length ? i.substr(1, 1) : i), ":before" === e ? t.insertBefore(o, t.firstChild) : t.appendChild(o);
                                    }
                                });
                            });
                        })(),
                        (Dt = !1),
                        e();
                }
            }
            function qt(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                if (h) {
                    var n = f.documentElement.classList,
                        r = function (t) {
                            return n.add(x + "-" + t);
                        },
                        a = function (t) {
                            return n.remove(x + "-" + t);
                        },
                        i = Object.keys(Bt),
                        o = ["." + Wt + ":not([" + b + "])"]
                            .concat(
                                i.map(function (t) {
                                    return "." + t + ":not([" + b + "])";
                                })
                            )
                            .join(", ");
                    if (0 !== o.length) {
                        var s = X(t.querySelectorAll(o));
                        if (s.length > 0) {
                            r("pending"), a("complete");
                            var c = ct.begin("onTree"),
                                l = s.reduce(function (t, e) {
                                    try {
                                        var n = Xt(e);
                                        n && t.push(n);
                                    } catch (t) {
                                        w || (t instanceof Tt && console.error(t));
                                    }
                                    return t;
                                }, []);
                            c(),
                                _t(l, function () {
                                    r("active"), r("complete"), a("pending"), "function" == typeof e && e();
                                });
                        }
                    }
                }
            }
            function Kt(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                    n = Xt(t);
                n && _t([n], e);
            }
            var Gt = function () {
                var t = "svg-inline--fa",
                    e = z.familyPrefix,
                    n = z.replacementClass,
                    r =
                        'svg:not(:root).svg-inline--fa {\n  overflow: visible; }\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em; }\n  .svg-inline--fa.fa-lg {\n    vertical-align: -.225em; }\n  .svg-inline--fa.fa-w-1 {\n    width: 0.0625em; }\n  .svg-inline--fa.fa-w-2 {\n    width: 0.125em; }\n  .svg-inline--fa.fa-w-3 {\n    width: 0.1875em; }\n  .svg-inline--fa.fa-w-4 {\n    width: 0.25em; }\n  .svg-inline--fa.fa-w-5 {\n    width: 0.3125em; }\n  .svg-inline--fa.fa-w-6 {\n    width: 0.375em; }\n  .svg-inline--fa.fa-w-7 {\n    width: 0.4375em; }\n  .svg-inline--fa.fa-w-8 {\n    width: 0.5em; }\n  .svg-inline--fa.fa-w-9 {\n    width: 0.5625em; }\n  .svg-inline--fa.fa-w-10 {\n    width: 0.625em; }\n  .svg-inline--fa.fa-w-11 {\n    width: 0.6875em; }\n  .svg-inline--fa.fa-w-12 {\n    width: 0.75em; }\n  .svg-inline--fa.fa-w-13 {\n    width: 0.8125em; }\n  .svg-inline--fa.fa-w-14 {\n    width: 0.875em; }\n  .svg-inline--fa.fa-w-15 {\n    width: 0.9375em; }\n  .svg-inline--fa.fa-w-16 {\n    width: 1em; }\n  .svg-inline--fa.fa-w-17 {\n    width: 1.0625em; }\n  .svg-inline--fa.fa-w-18 {\n    width: 1.125em; }\n  .svg-inline--fa.fa-w-19 {\n    width: 1.1875em; }\n  .svg-inline--fa.fa-w-20 {\n    width: 1.25em; }\n  .svg-inline--fa.fa-pull-left {\n    margin-right: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-pull-right {\n    margin-left: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-border {\n    height: 1.5em; }\n  .svg-inline--fa.fa-li {\n    width: 2em; }\n  .svg-inline--fa.fa-fw {\n    width: 1.25em; }\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em; }\n  .fa-layers svg.svg-inline--fa {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center; }\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center; }\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right; }\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left; }\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1em; }\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n';
                if ("fa" !== e || n !== t) {
                    var a = new RegExp("\\.fa\\-", "g"),
                        i = new RegExp("\\." + t, "g");
                    r = r.replace(a, "." + e + "-").replace(i, "." + n);
                }
                return r;
            };
            function Jt(t) {
                return { found: !0, width: t[0], height: t[1], icon: { tag: "path", attributes: { fill: "currentColor", d: t.slice(4)[0] } } };
            }
            var Zt = !1;
            function Qt() {
                z.autoAddCss && (Zt || $(Gt()), (Zt = !0));
            }
            function te(t, e) {
                return (
                    Object.defineProperty(t, "abstract", { get: e }),
                    Object.defineProperty(t, "html", {
                        get: function () {
                            return t.abstract.map(function (t) {
                                return xt(t);
                            });
                        },
                    }),
                    Object.defineProperty(t, "node", {
                        get: function () {
                            if (h) {
                                var e = f.createElement("div");
                                return (e.innerHTML = t.html), e.children;
                            }
                        },
                    }),
                    t
                );
            }
            function ee(t) {
                var e = t.prefix,
                    n = void 0 === e ? "fa" : e,
                    r = t.iconName;
                if (r) return yt(re.definitions, n, r) || yt(L.styles, n, r);
            }
            var ne,
                re = new ((function () {
                    function t() {
                        S(this, t), (this.definitions = {});
                    }
                    return (
                        O(t, [
                            {
                                key: "add",
                                value: function () {
                                    for (var t = this, e = arguments.length, n = Array(e), r = 0; r < e; r++) n[r] = arguments[r];
                                    var a = n.reduce(this._pullDefinitions, {});
                                    Object.keys(a).forEach(function (e) {
                                        (t.definitions[e] = M({}, t.definitions[e] || {}, a[e])),
                                            (function t(e, n) {
                                                var r = Object.keys(n).reduce(function (t, e) {
                                                    var r = n[e];
                                                    return r.icon ? (t[r.iconName] = r.icon) : (t[e] = r), t;
                                                }, {});
                                                "function" == typeof L.hooks.addPack ? L.hooks.addPack(e, r) : (L.styles[e] = M({}, L.styles[e] || {}, r)), "fas" === e && t("fa", n);
                                            })(e, a[e]);
                                    });
                                },
                            },
                            {
                                key: "reset",
                                value: function () {
                                    this.definitions = {};
                                },
                            },
                            {
                                key: "_pullDefinitions",
                                value: function (t, e) {
                                    var n = e.prefix && e.iconName && e.icon ? { 0: e } : e;
                                    return (
                                        Object.keys(n).map(function (e) {
                                            var r = n[e],
                                                a = r.prefix,
                                                i = r.iconName,
                                                o = r.icon;
                                            t[a] || (t[a] = {}), (t[a][i] = o);
                                        }),
                                        t
                                    );
                                },
                            },
                        ]),
                        t
                    );
                })())(),
                ae = function () {
                    var t;
                    T({ autoReplaceSvg: (t = !1), observeMutations: t }), St && St.disconnect();
                },
                ie = {
                    i2svg: function () {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        if (h) {
                            Qt();
                            var e = t.node,
                                n = void 0 === e ? f : e,
                                r = t.callback,
                                a = void 0 === r ? function () {} : r;
                            z.searchPseudoElements && Vt(n), qt(n, a);
                        }
                    },
                    css: Gt,
                    insertCss: function () {
                        $(Gt());
                    },
                },
                oe = {
                    transform: function (t) {
                        return At(t);
                    },
                },
                se =
                    ((ne = function (t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                            n = e.transform,
                            r = void 0 === n ? W : n,
                            a = e.symbol,
                            i = void 0 !== a && a,
                            o = e.mask,
                            s = void 0 === o ? null : o,
                            c = e.title,
                            l = void 0 === c ? null : c,
                            u = e.classes,
                            f = void 0 === u ? [] : u,
                            d = e.attributes,
                            p = void 0 === d ? {} : d,
                            m = e.styles,
                            h = void 0 === m ? {} : m;
                        if (t) {
                            var g = t.prefix,
                                v = t.iconName,
                                b = t.icon;
                            return te(M({ type: "icon" }, t), function () {
                                return (
                                    Qt(),
                                    z.autoA11y && (l ? (p["aria-labelledby"] = z.replacementClass + "-title-" + U()) : (p["aria-hidden"] = "true")),
                                    rt({
                                        icons: { main: Jt(b), mask: s ? Jt(s.icon) : { found: !1, width: null, height: null, icon: {} } },
                                        prefix: g,
                                        iconName: v,
                                        transform: M({}, W, r),
                                        symbol: i,
                                        title: l,
                                        extra: { attributes: p, styles: h, classes: f },
                                    })
                                );
                            });
                        }
                    }),
                    function (t) {
                        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                            n = (t || {}).icon ? t : ee(t || {}),
                            r = e.mask;
                        return r && (r = (r || {}).icon ? r : ee(r || {})), ne(n, M({}, e, { mask: r }));
                    }),
                ce = function (t) {
                    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                        n = e.transform,
                        r = void 0 === n ? W : n,
                        a = e.title,
                        i = void 0 === a ? null : a,
                        o = e.classes,
                        s = void 0 === o ? [] : o,
                        c = e.attributes,
                        l = void 0 === c ? {} : c,
                        u = e.styles,
                        f = void 0 === u ? {} : u;
                    return te({ type: "text", content: t }, function () {
                        return Qt(), at({ content: t, transform: M({}, W, r), title: i, extra: { attributes: l, styles: f, classes: [z.familyPrefix + "-layers-text"].concat(A(s)) } });
                    });
                },
                le = function (t) {
                    return te({ type: "layer" }, function () {
                        Qt();
                        var e = [];
                        return (
                            t(function (t) {
                                Array.isArray(t)
                                    ? t.map(function (t) {
                                          e = e.concat(t.abstract);
                                      })
                                    : (e = e.concat(t.abstract));
                            }),
                            [{ tag: "span", attributes: { class: z.familyPrefix + "-layers" }, children: e }]
                        );
                    });
                },
                ue = { noAuto: ae, dom: ie, library: re, parse: oe, findIconDefinition: ee, icon: se, text: ce, layer: le },
                fe = function () {
                    h && z.autoReplaceSvg && ue.dom.i2svg({ node: f });
                };
            Object.defineProperty(ue, "config", {
                get: function () {
                    return z;
                },
                set: function (t) {
                    T(t);
                },
            }),
                h &&
                    (function (t) {
                        try {
                            t();
                        } catch (t) {
                            if (!w) throw t;
                        }
                    })(function () {
                        m &&
                            (u.FontAwesome || (u.FontAwesome = ue),
                            R(function () {
                                Object.keys(L.styles).length > 0 && fe(),
                                    z.observeMutations &&
                                        "function" == typeof MutationObserver &&
                                        (function (t) {
                                            if (d) {
                                                var e = t.treeCallback,
                                                    n = t.nodeCallback,
                                                    r = t.pseudoElementsCallback;
                                                (St = new d(function (t) {
                                                    Dt ||
                                                        X(t).forEach(function (t) {
                                                            if (
                                                                ("childList" === t.type && t.addedNodes.length > 0 && !kt(t.addedNodes[0]) && (z.searchPseudoElements && r(t.target), e(t.target)),
                                                                "attributes" === t.type && t.target.parentNode && z.searchPseudoElements && r(t.target.parentNode),
                                                                "attributes" === t.type && kt(t.target) && ~_.indexOf(t.attributeName))
                                                            )
                                                                if ("class" === t.attributeName) {
                                                                    var a = bt(H(t.target)),
                                                                        i = a.prefix,
                                                                        o = a.iconName;
                                                                    i && t.target.setAttribute("data-prefix", i), o && t.target.setAttribute("data-icon", o);
                                                                } else n(t.target);
                                                        });
                                                })),
                                                    h && St.observe(f.getElementsByTagName("body")[0], { childList: !0, attributes: !0, characterData: !0, subtree: !0 });
                                            }
                                        })({ treeCallback: qt, nodeCallback: Kt, pseudoElementsCallback: Vt });
                            })),
                            (L.hooks = M({}, L.hooks, {
                                addPack: function (t, e) {
                                    (L.styles[t] = M({}, L.styles[t] || {}, e)), ht(), fe();
                                },
                                addShims: function (t) {
                                    var e;
                                    (e = L.shims).push.apply(e, A(t)), ht(), fe();
                                },
                            }));
                    });
            var de = ue.config;
            e.default = ue;
        },
        function (t, e, n) {
            "use strict";
            var r = function () {
                    var t = this,
                        e = t.$createElement,
                        n = t._self._c || e;
                    return n("div", { staticClass: "daterangepicker-calendar" }, [
                        n("div", { staticClass: "d-flex align-items-center" }, [
                            n("div", { staticClass: "p-1", class: 1 == t.calendarIndex ? "" : "invisible" }, [
                                n(
                                    "button",
                                    {
                                        staticClass: "btn btn-sm btn-light",
                                        attrs: { type: "button" },
                                        on: {
                                            mousedown: function (t) {
                                                t.preventDefault();
                                            },
                                            click: t.goToPrevMonth,
                                        },
                                    },
                                    [n("font-awesome-icon", { attrs: { icon: "caret-left", "fixed-width": "" } })],
                                    1
                                ),
                            ]),
                            t._v(" "),
                            n("div", { staticClass: "p-1 col text-center" }, [t._v("\n      " + t._s(t.displayMonth.format("MMMM YYYY")) + "\n    ")]),
                            t._v(" "),
                            n("div", { staticClass: "p-1", class: t.calendarIndex == t.calendarCount ? "" : "invisible" }, [
                                n(
                                    "button",
                                    {
                                        staticClass: "btn btn-sm btn-light",
                                        attrs: { type: "button" },
                                        on: {
                                            mousedown: function (t) {
                                                t.preventDefault();
                                            },
                                            click: t.goToNextMonth,
                                        },
                                    },
                                    [n("font-awesome-icon", { attrs: { icon: "caret-right", "fixed-width": "" } })],
                                    1
                                ),
                            ]),
                        ]),
                        t._v(" "),
                        n(
                            "div",
                            { staticClass: "d-flex justify-content-between text-center daterangepicker-calendar-row" },
                            t._l(t.daysOfFirstWeek, function (e) {
                                return n("div", { key: e.format("D"), staticClass: "col-day" }, [t._v(t._s(e.format("ddd")))]);
                            })
                        ),
                        t._v(" "),
                        n(
                            "div",
                            { staticClass: "d-flex flex-wrap justify-content-between text-center daterangepicker-calendar-row" },
                            t._l(t.days, function (e) {
                                return n(
                                    "div",
                                    {
                                        key: e.format("M-D"),
                                        staticClass: "col-day",
                                        class: t.dayClass(e),
                                        on: {
                                            mousedown: function (t) {
                                                t.preventDefault();
                                            },
                                            click: function (n) {
                                                t.dayClick(e);
                                            },
                                            mouseover: function (n) {
                                                t.blurOnHover();
                                            },
                                        },
                                    },
                                    [t._v(t._s(e.format("D")))]
                                );
                            })
                        ),
                    ]);
                },
                a = [];
            (r._withStripped = !0),
                n.d(e, "a", function () {
                    return r;
                }),
                n.d(e, "b", function () {
                    return a;
                });
        },
        function (t, e, n) {
            "use strict";
            var r = function () {
                    var t = this,
                        e = t.$createElement,
                        n = t._self._c || e;
                    return n(
                        "div",
                        { staticClass: "d-flex daterangepicker-row" },
                        [
                            t._l(t.calendarCount, function (e) {
                                return n(
                                    "div",
                                    { key: e, staticClass: "daterangepicker-col" },
                                    [
                                        n("date-range-picker-calendar", {
                                            attrs: {
                                                calendarIndex: e,
                                                calendarCount: t.calendarCount,
                                                month: t.month,
                                                startDate: t.startDate,
                                                endDate: t.endDate,
                                                compare: t.compare,
                                                startDateCompare: t.startDateCompare,
                                                endDateCompare: t.endDateCompare,
                                                step: t.step,
                                            },
                                            on: { goToPrevMonth: t.goToPrevMonth, goToNextMonth: t.goToNextMonth, selectDate: t.selectDate, nextStep: t.nextStep, blurOnHover: t.blurOnHover },
                                        }),
                                    ],
                                    1
                                );
                            }),
                            t._v(" "),
                            n("div", { staticClass: "daterangepicker-col" }, [
                                n("div", { staticClass: "form-group" }, [
                                    n(
                                        "select",
                                        {
                                            directives: [{ name: "model", rawName: "v-model", value: t.rangeSelect, expression: "rangeSelect" }],
                                            staticClass: "custom-select",
                                            class: t.compare ? "daterangepicker-range-border" : "",
                                            on: {
                                                change: function (e) {
                                                    var n = Array.prototype.filter
                                                        .call(e.target.options, function (t) {
                                                            return t.selected;
                                                        })
                                                        .map(function (t) {
                                                            return "_value" in t ? t._value : t.value;
                                                        });
                                                    t.rangeSelect = e.target.multiple ? n : n[0];
                                                },
                                            },
                                        },
                                        [
                                            t._l(t.ranges, function (e, r) {
                                                return n("option", { key: r, domProps: { value: r } }, [t._v(t._s(e.label))]);
                                            }),
                                            t._v(" "),
                                            n("option", { attrs: { value: "custom" } }, [t._v("Custom range")]),
                                        ],
                                        2
                                    ),
                                ]),
                                t._v(" "),
                                n("div", { staticClass: "form-group form-inline flex-nowrap" }, [
                                    n("input", {
                                        ref: "startDate",
                                        staticClass: `form-control w-100 daterangepicker-date-input ${t.step === null ? 'border-primary' : ''}`,
                                        attrs: { type: "text" },
                                        domProps: { value: t._f("dateFormat")(t.startDate) },
                                        on: {
                                            focus: function (e) {
                                                t.step = "selectStartDate";
                                            },
                                            blur: t.inputDate,
                                        },
                                    }),
                                    t._v(" "),
                                    n("span", { staticClass: "mx-2" }, [n("font-awesome-icon", { attrs: { icon: "caret-right", "fixed-width": "" } })], 1),
                                    t._v(" "),
                                    n("input", {
                                        ref: "endDate",
                                        staticClass: `form-control w-100 daterangepicker-date-input ${t.step === "selectEndDate" ? 'border-primary' : ''} `,
                                        attrs: { type: "text" },
                                        domProps: { value: t._f("dateFormat")(t.endDate) },
                                        on: {
                                                focus: function (e) {
                                                    t.step = "selectEndDate";
                                                },
                                            blur: t.inputDate,
                                        },
                                    }),
                                ]),
                                t._v(" "),
                                t.allowCompare
                                    ? n("div", { staticClass: "form-group" }, [
                                          n("div", { staticClass: "custom-control custom-checkbox" }, [
                                              n("input", {
                                                  directives: [{ name: "model", rawName: "v-model", value: t.compare, expression: "compare" }],
                                                  staticClass: "custom-control-input",
                                                  attrs: { type: "checkbox", id: "date-range-picker-compare-" + t._uid },
                                                  domProps: { checked: Array.isArray(t.compare) ? t._i(t.compare, null) > -1 : t.compare },
                                                  on: {
                                                      change: function (e) {
                                                          var n = t.compare,
                                                              r = e.target,
                                                              a = !!r.checked;
                                                          if (Array.isArray(n)) {
                                                              var i = t._i(n, null);
                                                              r.checked ? i < 0 && (t.compare = n.concat([null])) : i > -1 && (t.compare = n.slice(0, i).concat(n.slice(i + 1)));
                                                          } else t.compare = a;
                                                      },
                                                  },
                                              }),
                                              t._v(" "),
                                              n("label", { staticClass: "custom-control-label", attrs: { for: "date-range-picker-compare-" + t._uid } }, [t._v("Compare")]),
                                          ]),
                                      ])
                                    : t._e(),
                                t._v(" "),
                                t.compare
                                    ? n("div", [
                                          n("div", { staticClass: "form-group" }, [
                                              n(
                                                  "select",
                                                  {
                                                      directives: [{ name: "model", rawName: "v-model", value: t.rangeSelectCompare, expression: "rangeSelectCompare" }],
                                                      staticClass: "custom-select",
                                                      class: t.compare ? "daterangepicker-range-border compare" : "",
                                                      on: {
                                                          change: function (e) {
                                                              var n = Array.prototype.filter
                                                                  .call(e.target.options, function (t) {
                                                                      return t.selected;
                                                                  })
                                                                  .map(function (t) {
                                                                      return "_value" in t ? t._value : t.value;
                                                                  });
                                                              t.rangeSelectCompare = e.target.multiple ? n : n[0];
                                                          },
                                                      },
                                                  },
                                                  [
                                                      t._l(t.ranges, function (e, r) {
                                                          return n("option", { key: r, domProps: { value: r } }, [t._v(t._s(e.label))]);
                                                      }),
                                                      t._v(" "),
                                                      n("option", { attrs: { value: "custom" } }, [t._v("Custom range")]),
                                                  ],
                                                  2
                                              ),
                                          ]),
                                          t._v(" "),
                                          n("div", { staticClass: "form-group form-inline flex-nowrap" }, [
                                              n("input", {
                                                  ref: "startDateCompare",
                                                  staticClass: "form-control w-100 daterangepicker-date-input compare",
                                                  attrs: { type: "text" },
                                                  domProps: { value: t._f("dateFormat")(t.startDateCompare) },
                                                  on: {
                                                      focus: function (e) {
                                                          t.step = "selectStartDateCompare";
                                                      },
                                                      blur: t.inputDate,
                                                  },
                                              }),
                                              t._v(" "),
                                              n("span", { staticClass: "mx-2" }, [n("font-awesome-icon", { attrs: { icon: "caret-right", "fixed-width": "" } })], 1),
                                              t._v(" "),
                                              n("input", {
                                                  ref: "endDateCompare",
                                                  staticClass: "form-control w-100 daterangepicker-date-input compare",
                                                  attrs: { type: "text" },
                                                  domProps: { value: t._f("dateFormat")(t.endDateCompare) },
                                                  on: {
                                                      focus: function (e) {
                                                          t.step = "selectEndDateCompare";
                                                      },
                                                      blur: t.inputDate,
                                                  },
                                              }),
                                          ]),
                                      ])
                                    : t._e(),
                                t._v(" "),
                                n("div", { staticClass: "form-group form-inline justify-content-end mb-0" }, [
                                    n("button", { staticClass: "btn btn-light", attrs: { type: "button" }, on: { click: t.cancel } }, [t._v("Cancel")]),
                                    t._v(" "),
                                    n("button", { staticClass: "btn btn-primary ml-2", attrs: { type: "button",  }, on: { click: t.submit } }, [t._v("Submit")]),
                                ]),
                            ]),
                        ],
                        2
                    );
                },
                a = [];
            (r._withStripped = !0),
                n.d(e, "a", function () {
                    return r;
                }),
                n.d(e, "b", function () {
                    return a;
                });
        },
        function (t, e, n) {
            "use strict";
            function r(t, e) {
                for (var n = [], r = {}, a = 0; a < e.length; a++) {
                    var i = e[a],
                        o = i[0],
                        s = { id: t + ":" + a, css: i[1], media: i[2], sourceMap: i[3] };
                    r[o] ? r[o].parts.push(s) : n.push((r[o] = { id: o, parts: [s] }));
                }
                return n;
            }
            n.r(e),
                n.d(e, "default", function () {
                    return m;
                });
            var a = "undefined" != typeof document;
            if ("undefined" != typeof DEBUG && DEBUG && !a) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");
            var i = {},
                o = a && (document.head || document.getElementsByTagName("head")[0]),
                s = null,
                c = 0,
                l = !1,
                u = function () {},
                f = null,
                d = "data-vue-ssr-id",
                p = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());
            function m(t, e, n, a) {
                (l = n), (f = a || {});
                var o = r(t, e);
                return (
                    h(o),
                    function (e) {
                        for (var n = [], a = 0; a < o.length; a++) {
                            var s = o[a];
                            (c = i[s.id]).refs--, n.push(c);
                        }
                        e ? h((o = r(t, e))) : (o = []);
                        for (a = 0; a < n.length; a++) {
                            var c;
                            if (0 === (c = n[a]).refs) {
                                for (var l = 0; l < c.parts.length; l++) c.parts[l]();
                                delete i[c.id];
                            }
                        }
                    }
                );
            }
            function h(t) {
                for (var e = 0; e < t.length; e++) {
                    var n = t[e],
                        r = i[n.id];
                    if (r) {
                        r.refs++;
                        for (var a = 0; a < r.parts.length; a++) r.parts[a](n.parts[a]);
                        for (; a < n.parts.length; a++) r.parts.push(v(n.parts[a]));
                        r.parts.length > n.parts.length && (r.parts.length = n.parts.length);
                    } else {
                        var o = [];
                        for (a = 0; a < n.parts.length; a++) o.push(v(n.parts[a]));
                        i[n.id] = { id: n.id, refs: 1, parts: o };
                    }
                }
            }
            function g() {
                var t = document.createElement("style");
                return (t.type = "text/css"), o.appendChild(t), t;
            }
            function v(t) {
                var e,
                    n,
                    r = document.querySelector("style[" + d + '~="' + t.id + '"]');
                if (r) {
                    if (l) return u;
                    r.parentNode.removeChild(r);
                }
                if (p) {
                    var a = c++;
                    (r = s || (s = g())), (e = x.bind(null, r, a, !1)), (n = x.bind(null, r, a, !0));
                } else
                    (r = g()),
                        (e = function (t, e) {
                            var n = e.css,
                                r = e.media,
                                a = e.sourceMap;
                            r && t.setAttribute("media", r);
                            f.ssrId && t.setAttribute(d, e.id);
                            a && ((n += "\n/*# sourceURL=" + a.sources[0] + " */"), (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"));
                            if (t.styleSheet) t.styleSheet.cssText = n;
                            else {
                                for (; t.firstChild; ) t.removeChild(t.firstChild);
                                t.appendChild(document.createTextNode(n));
                            }
                        }.bind(null, r)),
                        (n = function () {
                            r.parentNode.removeChild(r);
                        });
                return (
                    e(t),
                    function (r) {
                        if (r) {
                            if (r.css === t.css && r.media === t.media && r.sourceMap === t.sourceMap) return;
                            e((t = r));
                        } else n();
                    }
                );
            }
            var b,
                y =
                    ((b = []),
                    function (t, e) {
                        return (b[t] = e), b.filter(Boolean).join("\n");
                    });
            function x(t, e, n, r) {
                var a = n ? "" : r.css;
                if (t.styleSheet) t.styleSheet.cssText = y(e, a);
                else {
                    var i = document.createTextNode(a),
                        o = t.childNodes;
                    o[e] && t.removeChild(o[e]), o.length ? t.insertBefore(i, o[e]) : t.appendChild(i);
                }
            }
        },
        function (t, e) {
            t.exports = function (t) {
                var e = [];
                return (
                    (e.toString = function () {
                        return this.map(function (e) {
                            var n = (function (t, e) {
                                var n = t[1] || "",
                                    r = t[3];
                                if (!r) return n;
                                if (e && "function" == typeof btoa) {
                                    var a = ((o = r), "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */"),
                                        i = r.sources.map(function (t) {
                                            return "/*# sourceURL=" + r.sourceRoot + t + " */";
                                        });
                                    return [n].concat(i).concat([a]).join("\n");
                                }
                                var o;
                                return [n].join("\n");
                            })(e, t);
                            return e[2] ? "@media " + e[2] + "{" + n + "}" : n;
                        }).join("");
                    }),
                    (e.i = function (t, n) {
                        "string" == typeof t && (t = [[null, t, ""]]);
                        for (var r = {}, a = 0; a < this.length; a++) {
                            var i = this[a][0];
                            "number" == typeof i && (r[i] = !0);
                        }
                        for (a = 0; a < t.length; a++) {
                            var o = t[a];
                            ("number" == typeof o[0] && r[o[0]]) || (n && !o[2] ? (o[2] = n) : n && (o[2] = "(" + o[2] + ") and (" + n + ")"), e.push(o));
                        }
                    }),
                    e
                );
            };
        },
        function (e, n) {
            e.exports = t;
        },
        function (t, e) {
            t.exports = {
                prefix: "fas",
                iconName: "caret-right",
                icon: [192, 512, [], "f0da", "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"],
            };
        },
        function (t, e, n) {
            (function (t) {
                (function (e, n) {
                    "use strict";
                    n = n && n.hasOwnProperty("default") ? n.default : n;
                    var r = "undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {};
                    var a,
                        i =
                            ((function (t) {
                                var e, n, a, i, o, s, c, l, u, f, d, p, m, h, g;
                                (e = r),
                                    (n = function (t, e, r) {
                                        if (!l(e) || f(e) || d(e) || p(e) || c(e)) return e;
                                        var a,
                                            i = 0,
                                            o = 0;
                                        if (u(e)) for (a = [], o = e.length; i < o; i++) a.push(n(t, e[i], r));
                                        else for (var s in ((a = {}), e)) Object.prototype.hasOwnProperty.call(e, s) && (a[t(s, r)] = n(t, e[s], r));
                                        return a;
                                    }),
                                    (a = function (t) {
                                        return m(t)
                                            ? t
                                            : (t = t.replace(/[\-_\s]+(.)?/g, function (t, e) {
                                                  return e ? e.toUpperCase() : "";
                                              }))
                                                  .substr(0, 1)
                                                  .toLowerCase() + t.substr(1);
                                    }),
                                    (i = function (t) {
                                        var e = a(t);
                                        return e.substr(0, 1).toUpperCase() + e.substr(1);
                                    }),
                                    (o = function (t, e) {
                                        return (function (t, e) {
                                            var n = (e = e || {}).separator || "_",
                                                r = e.split || /(?=[A-Z])/;
                                            return t.split(r).join(n);
                                        })(t, e).toLowerCase();
                                    }),
                                    (s = Object.prototype.toString),
                                    (c = function (t) {
                                        return "function" == typeof t;
                                    }),
                                    (l = function (t) {
                                        return t === Object(t);
                                    }),
                                    (u = function (t) {
                                        return "[object Array]" == s.call(t);
                                    }),
                                    (f = function (t) {
                                        return "[object Date]" == s.call(t);
                                    }),
                                    (d = function (t) {
                                        return "[object RegExp]" == s.call(t);
                                    }),
                                    (p = function (t) {
                                        return "[object Boolean]" == s.call(t);
                                    }),
                                    (m = function (t) {
                                        return (t -= 0) == t;
                                    }),
                                    (h = function (t, e) {
                                        var n = e && "process" in e ? e.process : e;
                                        return "function" != typeof n
                                            ? t
                                            : function (e, r) {
                                                  return n(e, t, r);
                                              };
                                    }),
                                    (g = {
                                        camelize: a,
                                        decamelize: o,
                                        pascalize: i,
                                        depascalize: o,
                                        camelizeKeys: function (t, e) {
                                            return n(h(a, e), t);
                                        },
                                        decamelizeKeys: function (t, e) {
                                            return n(h(o, e), t, e);
                                        },
                                        pascalizeKeys: function (t, e) {
                                            return n(h(i, e), t);
                                        },
                                        depascalizeKeys: function () {
                                            return this.decamelizeKeys.apply(this, arguments);
                                        },
                                    }),
                                    t.exports ? (t.exports = g) : (e.humps = g);
                            })((a = { exports: {} }), a.exports),
                            a.exports),
                        o =
                            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                ? function (t) {
                                      return typeof t;
                                  }
                                : function (t) {
                                      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                                  },
                        s =
                            ((function () {
                                function t(t) {
                                    this.value = t;
                                }
                                function e(e) {
                                    var n, r;
                                    function a(n, r) {
                                        try {
                                            var o = e[n](r),
                                                s = o.value;
                                            s instanceof t
                                                ? Promise.resolve(s.value).then(
                                                      function (t) {
                                                          a("next", t);
                                                      },
                                                      function (t) {
                                                          a("throw", t);
                                                      }
                                                  )
                                                : i(o.done ? "return" : "normal", o.value);
                                        } catch (t) {
                                            i("throw", t);
                                        }
                                    }
                                    function i(t, e) {
                                        switch (t) {
                                            case "return":
                                                n.resolve({ value: e, done: !0 });
                                                break;
                                            case "throw":
                                                n.reject(e);
                                                break;
                                            default:
                                                n.resolve({ value: e, done: !1 });
                                        }
                                        (n = n.next) ? a(n.key, n.arg) : (r = null);
                                    }
                                    (this._invoke = function (t, e) {
                                        return new Promise(function (i, o) {
                                            var s = { key: t, arg: e, resolve: i, reject: o, next: null };
                                            r ? (r = r.next = s) : ((n = r = s), a(t, e));
                                        });
                                    }),
                                        "function" != typeof e.return && (this.return = void 0);
                                }
                                "function" == typeof Symbol &&
                                    Symbol.asyncIterator &&
                                    (e.prototype[Symbol.asyncIterator] = function () {
                                        return this;
                                    }),
                                    (e.prototype.next = function (t) {
                                        return this._invoke("next", t);
                                    }),
                                    (e.prototype.throw = function (t) {
                                        return this._invoke("throw", t);
                                    }),
                                    (e.prototype.return = function (t) {
                                        return this._invoke("return", t);
                                    });
                            })(),
                            function (t, e, n) {
                                return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = n), t;
                            }),
                        c =
                            Object.assign ||
                            function (t) {
                                for (var e = 1; e < arguments.length; e++) {
                                    var n = arguments[e];
                                    for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                                }
                                return t;
                            },
                        l = function (t, e) {
                            var n = {};
                            for (var r in t) e.indexOf(r) >= 0 || (Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]));
                            return n;
                        };
                    function u(t, e) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
                            a = (e.children || []).map(u.bind(null, t)),
                            o = Object.keys(e.attributes || {}).reduce(
                                function (t, n) {
                                    var r = e.attributes[n];
                                    switch (n) {
                                        case "class":
                                            t.class = r.split(/\s+/).reduce(function (t, e) {
                                                return (t[e] = !0), t;
                                            }, {});
                                            break;
                                        case "style":
                                            t.style = r
                                                .split(";")
                                                .map(function (t) {
                                                    return t.trim();
                                                })
                                                .filter(function (t) {
                                                    return t;
                                                })
                                                .reduce(function (t, e) {
                                                    var n = e.indexOf(":"),
                                                        r = i.camelize(e.slice(0, n)),
                                                        a = e.slice(n + 1).trim();
                                                    return (t[r] = a), t;
                                                }, {});
                                            break;
                                        default:
                                            t.attrs[n] = r;
                                    }
                                    return t;
                                },
                                { class: {}, style: {}, attrs: {} }
                            ),
                            s = r.class,
                            f = void 0 === s ? {} : s,
                            d = r.style,
                            p = void 0 === d ? {} : d,
                            m = r.attrs,
                            h = void 0 === m ? {} : m,
                            g = l(r, ["class", "style", "attrs"]);
                        return "string" == typeof e
                            ? e
                            : t(
                                  e.tag,
                                  c(
                                      {
                                          class: (function () {
                                              for (var t = arguments.length, e = Array(t), n = 0; n < t; n++) e[n] = arguments[n];
                                              return e.reduce(function (t, e) {
                                                  return Array.isArray(e) ? (t = t.concat(e)) : t.push(e), t;
                                              }, []);
                                          })(o.class, f),
                                          style: c({}, o.style, p),
                                          attrs: c({}, o.attrs, h),
                                      },
                                      g,
                                      { props: n }
                                  ),
                                  a
                              );
                    }
                    var f = !1;
                    try {
                        f = !0;
                    } catch (t) {}
                    function d(t, e) {
                        return (Array.isArray(e) && e.length > 0) || (!Array.isArray(e) && e) ? s({}, t, e) : {};
                    }
                    function p(t) {
                        return null === t
                            ? null
                            : "object" === (void 0 === t ? "undefined" : o(t)) && t.prefix && t.iconName
                            ? t
                            : Array.isArray(t) && 2 === t.length
                            ? { prefix: t[0], iconName: t[1] }
                            : "string" == typeof t
                            ? { prefix: "fas", iconName: t }
                            : void 0;
                    }
                    var m = {
                            name: "FontAwesomeIcon",
                            functional: !0,
                            props: {
                                border: { type: Boolean, default: !1 },
                                fixedWidth: { type: Boolean, default: !1 },
                                flip: {
                                    type: String,
                                    default: null,
                                    validator: function (t) {
                                        return ["horizontal", "vertical", "both"].indexOf(t) > -1;
                                    },
                                },
                                icon: { type: [Object, Array, String], required: !0 },
                                mask: { type: [Object, Array, String], default: null },
                                listItem: { type: Boolean, default: !1 },
                                pull: {
                                    type: String,
                                    default: null,
                                    validator: function (t) {
                                        return ["right", "left"].indexOf(t) > -1;
                                    },
                                },
                                pulse: { type: Boolean, default: !1 },
                                rotation: {
                                    type: Number,
                                    default: null,
                                    validator: function (t) {
                                        return [90, 180, 270].indexOf(t) > -1;
                                    },
                                },
                                size: {
                                    type: String,
                                    default: null,
                                    validator: function (t) {
                                        return ["lg", "xs", "sm", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"].indexOf(t) > -1;
                                    },
                                },
                                spin: { type: Boolean, default: !1 },
                                transform: { type: [String, Object], default: null },
                                symbol: { type: [Boolean, String], default: !1 },
                            },
                            render: function (t, e) {
                                var r = e.props,
                                    a = r.icon,
                                    i = r.mask,
                                    o = r.symbol,
                                    l = p(a),
                                    m = d(
                                        "classes",
                                        (function (t) {
                                            var e,
                                                n =
                                                    ((e = {
                                                        "fa-spin": t.spin,
                                                        "fa-pulse": t.pulse,
                                                        "fa-fw": t.fixedWidth,
                                                        "fa-border": t.border,
                                                        "fa-li": t.listItem,
                                                        "fa-flip-horizontal": "horizontal" === t.flip || "both" === t.flip,
                                                        "fa-flip-vertical": "vertical" === t.flip || "both" === t.flip,
                                                    }),
                                                    s(e, "fa-" + t.size, null !== t.size),
                                                    s(e, "fa-rotate-" + t.rotation, null !== t.rotation),
                                                    s(e, "fa-pull-" + t.pull, null !== t.pull),
                                                    e);
                                            return Object.keys(n)
                                                .map(function (t) {
                                                    return n[t] ? t : null;
                                                })
                                                .filter(function (t) {
                                                    return t;
                                                });
                                        })(r)
                                    ),
                                    h = d("transform", "string" == typeof r.transform ? n.parse.transform(r.transform) : r.transform),
                                    g = d("mask", p(i)),
                                    v = n.icon(l, c({}, m, h, g, { symbol: o }));
                                if (!v)
                                    return (function () {
                                        var t;
                                        !f && console && "function" == typeof console.error && (t = console).error.apply(t, arguments);
                                    })("Check not find one or more icon(s)", l, g);
                                var b = v.abstract;
                                return u.bind(null, t)(b[0], {}, e.data);
                            },
                        },
                        h = {
                            name: "FontAwesomeLayers",
                            functional: !0,
                            props: { fixedWidth: { type: Boolean, default: !1 } },
                            render: function (t, e) {
                                var r,
                                    a,
                                    i = n.config.familyPrefix,
                                    o = e.data.staticClass,
                                    s = [i + "-layers"].concat(
                                        (function (t) {
                                            if (Array.isArray(t)) {
                                                for (var e = 0, n = Array(t.length); e < t.length; e++) n[e] = t[e];
                                                return n;
                                            }
                                            return Array.from(t);
                                        })(e.props.fixedWidth ? [i + "-fw"] : [])
                                    );
                                return t("div", c({}, e.data, { staticClass: ((r = o), (a = s), (0 === (r || "").length ? [] : [r]).concat(a).join(" ")) }), e.children);
                            },
                        },
                        g = {
                            name: "FontAwesomeLayersText",
                            functional: !0,
                            props: { value: { type: String, default: "" }, transform: { type: [String, Object], default: null } },
                            render: function (t, e) {
                                var r = e.props,
                                    a = d("transform", "string" == typeof r.transform ? n.parse.transform(r.transform) : r.transform),
                                    i = n.text(r.value, c({}, a)).abstract;
                                return u.bind(null, t)(i[0], {}, e.data);
                            },
                        };
                    n.noAuto(), (e.default = m), (e.FontAwesomeIcon = m), (e.FontAwesomeLayers = h), (e.FontAwesomeLayersText = g), Object.defineProperty(e, "__esModule", { value: !0 });
                })(e, n(7));
            }.call(this, n(20)));
        },
        function (t, e, n) {
            (t.exports = n(11)(!1)).push([
                t.i,
                ".daterangepicker-row{margin:-.5rem}.daterangepicker-col{padding:.5rem;flex-basis:100%}.daterangepicker-date-input{min-width:120px}.daterangepicker-range-border{border-color:#17a2b8!important}.daterangepicker-range-border.compare{border-color:#ff9307!important}.daterangepicker-date-input:focus{border-color:#17a2b8!important;box-shadow:0 0 0 .2rem rgba(23,162,184,.25)!important}.daterangepicker-date-input.compare:focus{border-color:#ff9307!important;box-shadow:0 0 0 .2rem rgba(255,147,7,.25)!important}",
                "",
            ]);
        },
        function (t, e, n) {
            "use strict";
            var r = n(0);
            n.n(r).a;
        },
        function (t, e, n) {
            (t.exports = n(11)(!1)).push([
                t.i,
                ".daterangepicker-calendar-row{font-size:14px}.col-day{width:14.28%;padding:.5rem 0;white-space:nowrap;cursor:default}.daterangepicker-range{background-color:#17a2b8!important;color:#fff}.daterangepicker-range-compare{background-color:#ff9307;color:#fff}.daterangepicker-range.daterangepicker-range-compare{background:linear-gradient(0,#ff9307 50%,#17a2b8 0)}.daterangepicker-cursor-pointer{cursor:pointer}",
                "",
            ]);
        },
        function (t, e, n) {
            "use strict";
            var r = n(1);
            n.n(r).a;
        },
        function (t, e) {
            t.exports = {
                prefix: "fas",
                iconName: "caret-left",
                icon: [192, 512, [], "f0d9", "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"],
            };
        },
        function (t, e) {
            var n;
            n = (function () {
                return this;
            })();
            try {
                n = n || Function("return this")() || (0, eval)("this");
            } catch (t) {
                "object" == typeof window && (n = window);
            }
            t.exports = n;
        },
        function (t, e, n) {
            "use strict";
            n.r(e);
            var r = n(8),
                a = n(3);
            for (var i in a)
                "default" !== i &&
                    (function (t) {
                        n.d(e, t, function () {
                            return a[t];
                        });
                    })(i);
            n(18);
            var o = n(6),
                s = Object(o.a)(a.default, r.a, r.b, !1, null, null, null);
            (s.options.__file = "src/components/DateRangePickerCalendar.vue"), (e.default = s.exports);
        },
        function (t, e, n) {
            "use strict";
            n.r(e);
            var r = n(9),
                a = n(5);
            for (var i in a)
                "default" !== i &&
                    (function (t) {
                        n.d(e, t, function () {
                            return a[t];
                        });
                    })(i);
            n(16);
            var o = n(6),
                s = Object(o.a)(a.default, r.a, r.b, !1, null, null, null);
            (s.options.__file = "src/components/DateRangePicker.vue"), (e.default = s.exports);
        },
    ]);
});
